<template>
    <md-content class="card md-layout-item md-size-100 md-small-size-100">
        <md-card class="md-form-card md-form-input md-mt-70">
            <md-toolbar class="md-toolbar md-table-toolbar md-transparent" md-elevation="0" v-if="hasAccess('PRIVILEGE_ORDER_PRODUCT_NEW')">
                <div class="md-toolbar-section-end">
                    <md-button class="md-subtitle-btn" to="product/create">
                        {{ $t('views.order.product.buttons.createProduct') }}
                    </md-button>
                </div>
            </md-toolbar>
            
            <md-card-content>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                        <md-field :class="getValidationClass('productId')">
                            <label for="product">{{ $t('views.order.product.form.label.product') }}</label>
                            <SelectWithFilter @mdselect="productChanged" :list="products" v-model="$v.form.productId.$model"
                                    :name="`product`" :id="`product`" :disabled="sending" v-slot="{item}">
                                    <md-option :value="item.id">{{ item.name }}</md-option>
                            </SelectWithFilter>
                            <span class="md-error" v-if="!$v.form.productId.required">{{ $t('validation.required') }}</span>
                            <server-error v-else field-name="productId" :server-errors="serverErrors" />
                        </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100">
                        <md-field>
                            <label for="category">{{ $t('views.order.product.form.label.category') }}</label>
                            <md-input :value="productCategory" id="category" name="category" :disabled="true" />
                        </md-field>
                    </div>
                </div>

                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                        <md-field :class="getValidationClass('description')">
                            <label for="description">{{ $t('views.order.product.form.label.description') }}</label>
                            <md-input v-model="$v.form.description.$model" id="description" name="description"
                                      :disabled="sending" required />
                            <span class="md-error" v-if="!$v.form.description.required">{{ $t('validation.required') }}</span>
                            <server-error v-else field-name="description" :server-errors="serverErrors" />
                        </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100">
                        <md-field :class="getValidationClass('duration')">
                            <label for="duration">{{ $t('views.order.product.form.label.duration') }}</label>
                            <md-input v-model="$v.form.duration.$model" id="duration" name="duration" :disabled="sending"
                                      required />
                            <span class="md-error" v-if="!$v.form.duration.required">{{ $t('validation.required') }}</span>
                            <span class="md-error" v-else-if="!$v.form.duration.numeric">{{ $t('validation.numeric') }}</span>
                            <span class="md-error" v-else-if="!$v.form.duration.greaterThan">{{ $t('validation.greaterThan', {0: $v.form.duration.$params.greaterThan.value}) }}</span>
                            <server-error v-else field-name="duration" :server-errors="serverErrors" />
                        </md-field>
                    </div>
                </div>
                
                <template v-if="isInternetOrOohOrder">
                    <div class="md-layout md-gutter" v-if="isInternetOrDaOrder">
                        <div class="md-layout-item md-small-size-100 md-size-100">
                            <md-field :class="getValidationClass('platformId')">
                                <label for="platform">{{ $t('views.order.product.form.label.platform') }}</label>
                                <SelectWithFilter :list="dictionaries.platform" v-model="$v.form.platformId.$model"
                                    :name="`platform`" :id="`platform`" :disabled="sending || !form.productId" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                            </md-field>
                        </div>
                    </div>
                    
                    <div class="md-layout md-gutter">
                        <div class="md-layout-item md-small-size-100 md-size-50" v-if="isInternetOrDaOrder">
                            <md-field :class="getValidationClass('serTypeId')">
                                <label for="serType">{{ $t('views.order.product.form.label.adFormat') }}</label>
                                <SelectWithFilter :list="defaultAdFormat()" v-model="$v.form.serTypeId.$model"
                                    :name="`serType`" :id="`serType`" :disabled="sending || !form.productId" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.serTypeId.required">{{ $t('validation.required') }}</span>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="getValidationClass('blockTypeId')">
                                <label for="blockType">{{ $t('views.order.product.form.label.blockType') }}</label>
                                <SelectWithFilter :list="getBlockType()" v-model="$v.form.blockTypeId.$model"
                                    :name="`blockType`" :id="`blockType`" :disabled="sending || !form.productId" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.blockTypeId.required">{{ $t('validation.required') }}</span>
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout md-gutter" v-if="isInternetOrDaOrder">
                        <div class="md-layout-item md-small-size-100 md-size-50">
                            <md-field :class="getValidationClass('genreId')">
                                <label for="genre">{{ $t('views.order.product.form.label.genre') }}</label>
                                <SelectWithFilter :list="defaultGenre()" v-model="$v.form.genreId.$model"
                                    :name="`genresType`" :id="`genresType`" :disabled="sending || !form.productId" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.genreId.required">{{ $t('validation.required') }}</span>
                            </md-field>
                        </div>

                        <div class="md-layout-item md-small-size-100 md-size-50" v-if="isInternetOrDaOrder">
                            <md-field :class="getValidationClass('cappingId')">
                                <label for="capping">{{ $t('views.order.product.form.label.capping') }}</label>
                                <SelectWithFilter :list="dictionaries.cappings" v-model="$v.form.cappingId.$model"
                                    :name="`capping`" :id="`capping`" :disabled="sending || !form.productId" v-slot="{item}">
                                    <md-option :value="item.valueId">{{ item.name }}</md-option>
                                </SelectWithFilter>
                                <span class="md-error" v-if="!$v.form.cappingId.required">{{ $t('validation.required') }}</span>
                            </md-field>
                        </div>
                    </div>
                </template>
            </md-card-content>

            <md-card-actions>
                <md-button class="md-primary" @click="$emit('cancel')">{{ $t('views.order.product.buttons.cancel') }}</md-button>
                <md-button class="md-accent md-raised" @click="goToNextStep">{{ $t('views.order.product.buttons.nextStep') }}</md-button>
            </md-card-actions>
        </md-card>
    </md-content>
</template>
<script>
    import {required, numeric} from 'vuelidate/lib/validators';
    import ServerError from '@/components/ServerError'
    import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
    import {dictionariesEndpoint} from '@/services/adsign-backend/endpoints';
    import {greaterThan} from '@/validators/validators';
    import {mapGetters} from 'vuex';
    import SelectWithFilter from '@/components/SelectWithFilter'
    import {OrderType} from '@/mixins/dictionariesConst';

    export default {
        name: 'OrderProductStep1',
        mixins: [serverSideValidationErrors],
        components: { ServerError, SelectWithFilter },
        props: {
            currentOrder:{
                type: Object,
                required: true
            },
            value: {
                type: Object,
                required: true
            },
            products: {
                type: Array,
                required: true
            },
            orderType: {
                type: String,
                required: true
            }
        },
        computed: {
            isInternetOrOohOrder() {
                return this.orderType === OrderType.Internet || this.orderType === OrderType.OOH || this.orderType === OrderType.DA;
            },
            isInternetOrDaOrder() {
                return this.orderType === OrderType.Internet || this.orderType === OrderType.DA;
            },
            isOohOrder() {
                return this.orderType === OrderType.OOH;
            },
            isDaOrder() {
              return this.orderType === OrderType.DA;  
            },
            selectedProduct: {
                get() {
                    if (this.form.productId) {
                        return this.products.find(item => item.id == this.form.productId);
                    }
                    return null;
                }
            },
            productCategory: {
                get() {
                    if (this.selectedProduct && this.selectedProduct.category) {
                        const category = this.dictionaries.categories.find(item => item.valueId == this.selectedProduct.category.valueId);
                        if (category) {
                            return `${category.name} (${category.shortName})`;
                        }
                    }
                    return null;
                }
            },
            ...mapGetters('auth', ['hasAccess', 'userId'])
        },
        data: function() {
            return {
                dictionaries: {
                    categories: [],
                    platform: [],
                    cappings: [],
                    genres: [],
                    serTypes: [],
                    blockTypes:[]
                },
                sending: false,
                form: {
                    categoryId: this.value.categoryId,
                    productId: this.value?.productId,
                    description: this.value.description,
                    duration: this.value.duration,
                    serTypeId: this.value.serTypeId,
                    genreId: this.value.genreId,
                    cappingId: this.value.cappingId,
                    blockTypeId: this.value.blockTypeId,
                    platformId: this.value.platformId
                }
            }
        },
        methods: {
            defaultGenre() {
                if(this.isDaOrder)
            return this.dictionaries?.genres?.filter(item => item.shortName == "CPM")
                else 
            return this.dictionaries.genres;
            },
            defaultAdFormat() {
                if(this.isDaOrder)
            return this.dictionaries?.serTypes?.filter(item => item.shortName == 'APMR')
            else 
            return this.dictionaries.serTypes;
            },
            loadDictionaries() {
                const promises = [];

                promises.push(dictionariesEndpoint.getDictionary('product_type').then(result => this.dictionaries.categories = result.data));

                if (this.isInternetOrDaOrder) {
                    promises.push(dictionariesEndpoint.getDictionary('ser_type').then(result => this.dictionaries.serTypes = result.data));
                    promises.push(dictionariesEndpoint.getDictionary('genre').then(result => this.dictionaries.genres = result.data));
                    promises.push(dictionariesEndpoint.getDictionary('prog_category').then(result => this.dictionaries.cappings = result.data));
                    promises.push(dictionariesEndpoint.getDictionary('acq_type').then(result => this.dictionaries.platform = result.data))
                }

                if (this.isInternetOrOohOrder) {
                    promises.push(dictionariesEndpoint.getDictionary('block_type').then(result => this.dictionaries.blockTypes = result.data));
                }

                return Promise.all(promises);
            },
            productChanged() {
                this.form.duration = this.form.duration || this.selectedProduct?.duration;
            },
            goToNextStep() {
                this.$v.$touch();

                if (!this.$v.$invalid) {
                    this.$emit('input', {
                        ...this.form,
                        isInternetOrOohOrder: this.isInternetOrOohOrder
                    });
                    this.$emit('nextStep');
                }
            },
            getBlockType() {
                return this.dictionaries?.blockTypes?.filter(item => item.type !== "Blok")
            }
        },
        mounted() {
            this.loadDictionaries().then(() => {
                this.form.genreId = this.form.genreId || this.dictionaries.genres.find(item => item.shortName == 'CPM')?.valueId
                this.form.cappingId = this.form.cappingId || this.dictionaries.cappings.find(item => item.shortName == 'BEZ CAPPINGU')?.valueId
                if(this.isDaOrder)
                this.form.serTypeId = this.dictionaries.serTypes.find(item => item.shortName == 'APMR')?.valueId

            });
            this.$watch(() => this.value, newValue => {
                this.form = {
                    categoryId: newValue.categoryId,
                    productId: newValue.productId,
                    description: newValue.description,
                    duration: newValue.duration,
                    serTypeId: newValue.serTypeId,
                    genreId: newValue.genreId,
                    cappingId: newValue.cappingId,
                    blockTypeId: newValue.blockTypeId,
                    platformId: newValue.platformId
                }
            });
        },
        validations() {
            return {
                form: {
                    categoryId: {},
                    productId: {
                        required
                    },
                    description: {
                        required
                    },
                    duration: {
                        required,
                        numeric,
                        greaterThan: greaterThan(0)
                    },
                    relatedProductId: {},
                    ...this.isInternetOrOohOrder && ({
                        blockTypeId: {
                            required
                        },
                        ...this.isInternetOrDaOrder && ({
                            serTypeId: {
                                required
                            },
                            genreId: {
                                required
                            },
                            cappingId: {
                                required
                            },
                            platformId: {
                                
                            }
                        }),
                    }),
                }
            }
        }
    }
</script>

<style scoped lang='scss'>
    .filter{
      padding: 8px;
      border: none;
      border-bottom: 1px solid black;
      margin: 0px 10px 0px 10px;
      font-size: 15px;
    }
</style>
